export class AuthHttp {

    /**
     * Login the user
     * @param username
     * @param password
     * @returns {Promise<void>}
     */
    static async login(username, password) {
        try {
            return await window.axios.get(`auth`, {auth: {username, password}}).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
